import { Document } from 'slate';
import BlockTypes from '../../../types/BlockTypes';
import groupCellsByTable from '../utils/groupCellsByTable';
export default function makeGetFragmentFromTableSelection(store) {
  return {
    getFragmentFromTableSelection: function getFragmentFromTableSelection(editor) {
      var cells = editor.getSelectedTableCells();
      var cellsCoords = editor.getCellsCoords(cells);
      var columnWithBreak = Math.abs(cellsCoords.first()[1] - cellsCoords.last()[1]) + 1;
      cells = cells.map(function (node, i) {
        return node.setIn(['data', 'rowBreak'], (i + 1) % columnWithBreak === 0);
      });
      return Document.create({
        nodes: groupCellsByTable(cells).map(function (cells, tableId) {
          return {
            object: 'block',
            type: BlockTypes.TABLE,
            data: {
              tableId: tableId
            },
            nodes: cells
          };
        }).toList()
      });
    }
  };
}